import { Observable, BehaviorSubject, Subject } from "rxjs";
import * as signalR from "@microsoft/signalr";

export class SignalRBaseService {
  protected hubConnection: signalR.HubConnection;

  private eventsSubjects: { [prop: string]: Subject<any> } = {};

  readonly events$: { [prop: string]: Observable<any> } = {};

  public connecting: boolean = false;

  private connectedSubject: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  public connected$ = this.connectedSubject.asObservable();

  // readonly statusProcesoCarga$ = this.ProcesoCargaSubjectsubject.asObservable();

  constructor(
    protected url: string,
    private events: string[] = [],
    startOnCreate: boolean = true
  ) {
    this.buildSubjects();
    if (startOnCreate) {
      this.startConnection();
      this.buildEvents();
    }
  }

  protected startConnection = () => {
    this.connecting = true;
    this.connectedSubject.next(false);
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.url)
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .then(() => {
        this.connecting = false;
        this.hubConnection.invoke("GetConnectionId").then((connectionId) => { });

        this.bindActions();
        this.connectedSubject.next(true);
      })
      .catch((err) => {
        this.connecting = false;
        this.connectedSubject.next(false);
      });
  };

  private buildEvents = () => {
    if (this.hubConnection) {
      this.hubConnection.onreconnected((connectionId) => {
        console.assert(
          this.hubConnection.state === signalR.HubConnectionState.Connected
        );
        this.startConnection();
      });

      this.hubConnection.onreconnecting((error) => {
        console.assert(
          this.hubConnection.state === signalR.HubConnectionState.Reconnecting
        );
      });
    }
  };

  private buildSubjects = () => {
    this.eventsSubjects = {};
    this.events.forEach((e) => {
      this.eventsSubjects[e] = new Subject();
      this.events$[e] = this.eventsSubjects[e].asObservable();
    });
  };

  private bindActions = () => {
    this.events.forEach((e) => {
      this.hubConnection.on(e, (data) => {
        console.log("evento llegó : ", e);
        this.eventsSubjects[e].next(data);
      });
    });
  };

  reconnect = () => {
    this.startConnection();
  };

  disconnect = () => {
    this.hubConnection.stop();
  };

  get connected() {
    return this.connectedSubject.value;
  }
}
